import { JOGGResponse } from "@jog/types"

import { JoggApiOption } from "./client"

export const applyGiftcardBase =
    ({ setToken, execute }: Pick<JoggApiOption, "execute" | "setToken">) =>
    async (cartId: string, giftcardCode: string): Promise<JOGGResponse<void>> =>
        execute(
            await setToken({
                method: "POST",
                uri: `/ctp/carts/${cartId}/applyGiftcard`,
                body: { giftcardCode },
            })
        )
